import { render, staticRenderFns } from "./CarouselIndicators.vue?vue&type=template&id=066e1964&scoped=true"
import script from "./CarouselIndicators.vue?vue&type=script&setup=true&lang=ts"
export * from "./CarouselIndicators.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CarouselIndicators.vue?vue&type=style&index=0&id=066e1964&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066e1964",
  null
  
)

export default component.exports